var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"custom-border-box"},[_c('v-card-title',[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('v-card-text',{staticClass:"body-2"},[_c('ul',_vm._l((_vm.listItems),function(item){return _c('li',{key:item},[_c('span',[_vm._v(_vm._s(item))])])}),0)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }